import React from 'react'
import ChatbotContainer from './components/feed'
import AmplifyBot from '../AmplifyBot'

const ChatBot = (props = {}) => {
    const { botname, Interactions } = props

    if(botname || Interactions) {
        return <AmplifyBot {...props} />
    } 
    
    return <ChatbotContainer {...props} />
}

export default ChatBot